import { createFileRoute, Outlet } from "@tanstack/react-router";
import AppLayout from "@/components/ui/layout/app-layout/app-layout";

export const Route = createFileRoute("/(dasboard)")({
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <main className="bg-gray-50">
      <AppLayout>
        <Outlet />
      </AppLayout>
    </main>
  );
}
